import { render, staticRenderFns } from "./inventoryDashboard.vue?vue&type=template&id=48684a04&scoped=true&"
import script from "./inventoryDashboard.vue?vue&type=script&lang=js&"
export * from "./inventoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./inventoryDashboard.vue?vue&type=style&index=0&id=48684a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48684a04",
  null
  
)

export default component.exports